<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mhVM4K/html/docimages/cover_ader.jpg?1684274658195" alt="This image is the cover for the book Passion for Israel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Passion for Israel
      </h1>
      <p class="bookDescription body article font2">
        <p>This book is written to counter a new sort of anti-Semitism Replacement Theology - and to address other destructive widespread distortions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel  C. Juster
      </h2>
      
      <p class="authorDescription body article">Dr. Juster, a pioneer in the Messianic Jewish Movement, was senior Rabbi of Beth Messiah Cong. In Maryland. The General Secretary of UMJC. Dr. Juster is the Director of Tikkun International.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Messianic Jewish Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?670f4cbe